export * from './exam-event-details-dialog.component';
